export enum ClarabridgeAppType {
	NONE = 'NONE',
	STUDIO = 'STUDIO',
	ANALYZE = 'ANALYZE',
	ENGAGOR = 'ENGAGOR',
	CONNECTORS = 'CONNECTORS'
}